import { fetcher } from '@/lib/api/fetch'

/**
 * Fetches permission metadata from the backend
 * This includes all permission definitions, categories, labels, and dependencies
 */
export const fetchPermissionMetadata = async context => {
  const res = await fetcher(
    '/api/admin/permissions/metadata',
    { method: 'GET' },
    context,
  )

  if (!res.ok) {
    throw new Error('Failed to fetch permission metadata')
  }

  return await res.json()
}

/**
 * Transform backend permission metadata into frontend-friendly format
 */
export const transformPermissionMetadata = metadata => {
  const categories = metadata?.categories || []

  // Create a flat list of all permissions for checkbox all/none functionality
  const allPermissionNames = []

  // Create sections for the UI
  const sections = categories
    .sort((a, b) => a.order - b.order)
    .map(category => {
      const permissions = category.permissions.map(perm => {
        allPermissionNames.push(perm.name)
        return {
          name: perm.name,
          label: perm.label,
          description: perm.description,
        }
      })

      return {
        name: category.name,
        title: category.label,
        description: category.description,
        permissions,
      }
    })

  return {
    sections,
    allPermissionNames,
  }
}
